export const FEEDBACK_SUBMIT_SUCCESS_MESSAGE =
  'Feedback submitted successfully';
